import { Component, OnInit, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PostFilter } from 'src/app/shared/interfaces/post/post-filter.interface'
import { PostListItem } from 'src/app/shared/interfaces/post/post-list-item.interface'
import { RouterModule } from '@angular/router'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import {
    NgbDropdownModule,
    NgbModal,
    NgbModalModule,
    NgbOffcanvas,
    NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { PostDetailComponent } from 'src/app/secure/modules/posts/components/post-detail/post-detail.component'
import { PostSearchComponent } from 'src/app/secure/modules/posts/components/post-search/post-search.component'
import { EmptyComponent } from 'src/app/shared/components/empty/empty.component'
import { PostPulloutComponent } from 'src/app/shared/components/posts/post-pullout/post-pullout.component'
import { PaginationDetailComponent } from 'src/app/shared/components/pagination-detail/pagination-detail.component'
import { PostsStore } from './posts.store'
import { AppStore } from 'src/app/core/app.store'
import { PostService } from 'src/app/core/services/posts/post.service'
import { ImagePickerOption } from 'src/app/shared/interfaces/image-picker/image-picker-option.interface'
import { ImagePickerModalComponent } from 'src/app/shared/components/image-picker-modal/image-picker-modal.component'
import { PdfModalService } from 'src/app/shared/components/pdf-modal/pdf-modal.service'
import { SmartQuoteService } from 'src/app/core/services/smartquote/smartquote.service'
import { PostFileType } from 'src/app/shared/interfaces/post/post-file.interface'

@Component({
    selector: 'sf-posts',
    imports: [
        CommonModule,
        RouterModule,
        NgbDropdownModule,
        NgbPaginationModule,
        NgbModalModule,
        PaginationDetailComponent,
        CardComponent,
        ButtonComponent,
        PostDetailComponent,
        PostSearchComponent,
        EmptyComponent,
    ],
    templateUrl: './posts.component.html',
    styleUrls: ['./posts.component.scss'],
})
export class PostsComponent implements OnInit {
    private offcanvas = inject(NgbOffcanvas)

    appStore = inject(AppStore)
    postsStore = inject(PostsStore)
    #postService = inject(PostService)
    #modalService = inject(NgbModal)
    #smartquoteService = inject(SmartQuoteService)
    #pdfModalService = inject(PdfModalService)

    filter: PostFilter = {
        pageNumber: 1,
        pageSize: 20,
        sortColumn: 'createdDate',
        isProcessed: false,
    }

    ngOnInit(): void {
        this.postsStore.changePage(1)
        this.postsStore.load(this.filter)
    }

    reloadPosts(): void {
        this.filter = { ...this.filter, sortColumn: 'createdDate', isProcessed: false, isVoid: false, pageNumber: 1 }
        this.postsStore.updateFilter(this.filter)
    }

    onlyMine(): void {
        this.filter = { ...this.filter, inChargeStaffId: this.appStore.me()?.id }
        this.postsStore.updateFilter(this.filter)
    }

    showAssignedAndUnassigned() {
        this.filter = { ...this.filter, inChargeStaffId: undefined }
        this.postsStore.updateFilter(this.filter)
    }

    pageChanged(page: number): void {
        this.postsStore.changePage(page)
    }

    onPostClick(post: PostListItem): void {
        const postPullout = this.offcanvas.open(PostPulloutComponent, { scroll: true, position: 'end' })
        postPullout.componentInstance.post = post
        postPullout.closed.subscribe(() => {})
    }

    openPDFModal(post: PostListItem, selectedImages?: ImagePickerOption[]) {
        const selectedImageIds = selectedImages?.map((image) => image.id)
        const getPDF = [73, 74].includes(post.postTypeId)
            ? this.#smartquoteService.downloadPdf(parseInt(post.t1!))
            : this.#postService.getPostCertificate(post.id, selectedImageIds)

        getPDF.subscribe({
            next: (response) => {
                const modalTitle = post.postType?.endsWith('Certificate')
                    ? post.postType
                    : `${post.postType} Certificate`
                this.#pdfModalService.openModal(response, modalTitle)
            },
        })
    }

    viewCertificate(postListItem: PostListItem) {
        if (postListItem.postImagesCount === 0) {
            this.openPDFModal(postListItem)
            return
        }

        this.#postService.getPostbyId(postListItem.id).subscribe((post) => {
            const imagePickerOptions: ImagePickerOption[] =
                post.images
                    .filter((x) => x.fileType == PostFileType.Image)
                    .map((image) => ({ id: image.id, url: image.fullUrl })) ?? []
            const modalRef = this.#modalService.open(ImagePickerModalComponent, { size: 'xl' })
            modalRef.componentInstance.title = 'Select Certificate Images'
            modalRef.componentInstance.options = imagePickerOptions
            modalRef.result.then((selectedImages) => this.openPDFModal(postListItem, selectedImages))
        })
    }
}
